<template>
  <div class="fwsed-dashboard">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="welcome-title">
        {{ $t("common.hi") }}, <span>{{ userName }}</span>
      </div>
      <b-button size="sm" variant="light" @click="refreshActiveTab">
        <i class="bx bx-refresh"></i>
        {{ $t("common.refresh") }}
      </b-button>
    </div>

    <b-tabs v-model="activeTabIndex">
      <b-tab :title="$t('firm.audit.dashboard.general')" key="general">
        <fwsed-overview-section ref="overviewSection" />
        <div class="mt-4"><fwsed-summary-table ref="summaryTable" /></div>
      </b-tab>

      <b-tab :title="$t('firm.audit.dashboard.by-firm')" key="firm">
        <keep-alive>
          <fwsed-firm-detail v-if="activeTab === 'firm'" ref="firmDetail" />
        </keep-alive>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import FwsedFirmDetail from "./components/fwsed-firm-detail.vue";
import FwsedOverviewSection from "./components/fwsed-overview-section.vue";
import FwsedSummaryTable from "./components/fwsed-summary-table.vue";

export default {
  name: "FwsedDashboard",
  components: { FwsedOverviewSection, FwsedSummaryTable, FwsedFirmDetail },
  data() {
    return {
      tabs: ["general", "firm"],
      activeTabIndex: 0,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/account"] || {};
    },
    userName() {
      return (this.user && this.user.name) || "";
    },
    activeTab() {
      return this.tabs[this.activeTabIndex] || "general";
    },
  },
  methods: {
    async refreshActiveTab() {
      if (this.activeTab === "general") {
        const overview = this.$refs.overviewSection;
        const summary = this.$refs.summaryTable;
        const tasks = [];

        if (overview && typeof overview.refresh === "function") {
          tasks.push(overview.refresh());
        }
        if (summary && typeof summary.refresh === "function") {
          tasks.push(summary.refresh());
        }
        await Promise.all(tasks);
      } else if (this.activeTab === "firm") {
        const firmDetail = this.$refs.firmDetail;
        if (firmDetail && typeof firmDetail.refresh === "function") {
          await firmDetail.refresh();
        }
      }
    },
  },
};
</script>

<style scoped>
.fwsed-dashboard .welcome-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.fwsed-dashboard .welcome-title span {
  color: #4b72fa;
}
</style>
